import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";

function AllNative() {
  const [allAdvertiseNativeUserTag, setAllAdvertiseNativeUserTag] = useState();

  useEffect(() => {
    getAllAdvertiseNativeUser();
  }, []);

  const getAllAdvertiseNativeUser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allAdvertiseNativeUser = await sendRequestGetAllAdvertiseNativeUser();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setAllAdvertiseNativeUserTag(
      await generateAllAdvertiseNativeUserTag(allAdvertiseNativeUser)
    );
  };

  const generateConfirmTag = (confirm) => {
    let classNameConfirmAdvertise;
    let textConfirmAdvertise;
    switch (confirm) {
      case 0:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "در حال بررسی";
        break;
      case 1:
        classNameConfirmAdvertise = "success";
        textConfirmAdvertise = "تایید شده";
        break;
      case 2:
        classNameConfirmAdvertise = "danger";
        textConfirmAdvertise = "رد شده";
        break;
    }

    return [classNameConfirmAdvertise, textConfirmAdvertise];
  };

  const sendRequestDeleteAdvertiseNativeUser = async (
    advertiseNativeUserID
  ) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/manage/native/" +
          advertiseNativeUserID,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const deleteAdvertiseNativeUser = async (advertiseNativeUserID) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }

    if (await sendRequestDeleteAdvertiseNativeUser(advertiseNativeUserID)) {
      await getAllAdvertiseNativeUser();
    }
  };

  const generateAllAdvertiseNativeUserTag = async (
    allAdvertiseNativeUserTag
  ) => {
    return allAdvertiseNativeUserTag.map((advertiseNativeUserTag, index) => {
      let classNameStateAdvertise = advertiseNativeUserTag.adv_active
        ? "success"
        : "danger";
      let textStateAdvertise = advertiseNativeUserTag.adv_active
        ? "فعال"
        : "غیر فعال";
      const [classNameConfirmAdvertise, textConfirmAdvertise] =
        generateConfirmTag(advertiseNativeUserTag.adv_confirm);

      return (
        <tr>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>{helpersNumbers.toPersianNum(advertiseNativeUserTag.adv_id)}</td>
          <td>
            {helpersNumbers.toPersianNum(advertiseNativeUserTag.adv_user_id)}
          </td>
          <td>
            {helpersNumbers.toPersianNum(
              advertiseNativeUserTag.adv_campaign_id
            )}
          </td>
          <td>
            {helpersNumbers.toPersianNum(advertiseNativeUserTag.adv_created_at)}
          </td>
          <td>
            {helpersNumbers.toPersianNum(advertiseNativeUserTag.adv_updated_at)}
          </td>
          <td className=" text-center">
            <a
              className="btn btn-primary text-center"
              target="_blank"
              href={advertiseNativeUserTag.link}
            >
              <i className="fa fa-globe"></i>
            </a>
          </td>
          <td>
            <div className="text-center">
              <span className={`badge badge-${classNameStateAdvertise} `}>
                {textStateAdvertise}
              </span>
            </div>
          </td>
          <td>
            <div className="text-center">
              <span className={`badge badge-${classNameConfirmAdvertise}`}>
                {textConfirmAdvertise}
              </span>
            </div>
          </td>
          <td>
            <div>
              <span className="pl-2">
                <Link
                  to={
                    `/advertise/manage/native/edit/` +
                    advertiseNativeUserTag.adv_id
                  }
                  className="btn btn-outline-success  "
                >
                  <i className="fa fa-edit"></i>
                </Link>
              </span>
              <span>
                <span
                  onClick={(e) => {
                    deleteAdvertiseNativeUser(advertiseNativeUserTag.adv_id);
                  }}
                  className="btn btn-outline-danger  btn-danger"
                >
                  <i className="fa fa-trash"></i>
                </span>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  const sendRequestGetAllAdvertiseNativeUser = async () => {
    const headersRequest = getHeaderForRequest();
    let allAdvertiseNativeUser;
    try {
      allAdvertiseNativeUser = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/advertise/manage/native",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allAdvertiseNativeUser.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar openItem="manage-advertise" activeItem="all-advertise-native" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">مدیریت تبلیغات همسان</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                <Link
                  className="btn btn-danger mb-3"
                  to="/advertise/manage/native/all/deleted"
                >
                  <span class="pl-2">
                    <i class="fa fa-trash"></i>
                  </span>
                  <span>
                    <span>تبلیغ های بنری حذف شده</span>
                  </span>
                </Link>
              </div>
              <div className="table-responsive pt-1">
                <table className="table table-bordered table-dark tbl-td-white-space table-hover mb-0">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره تبلیغ</td>
                      <td>شماره کاربری</td>
                      <td>شماره کمپین</td>
                      <td>تاریخ ایجاد</td>
                      <td>تاریخ بروزرسانی</td>
                      <td>آدرس فرود</td>
                      <td>وضعیت</td>
                      <td>بررسی</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>{allAdvertiseNativeUserTag}</tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllNative;
